import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env";
import { ServicesProvidedDTO } from "@shared/models/services-provided-dto";

@Injectable({
  providedIn: "root"
})
export class ServicesTypeService {
  private servicesTypeUrl = "services-provided/";

  constructor(private http: HttpClient) {}

  filter(params?) {
    return this.http.get<ServicesProvidedDTO[]>(
      `${environment.apiUrl}${this.servicesTypeUrl}filters`,
      { params: params }
    );
  }

  getServiceCategories() {
    return this.http.get<any[]>(`${environment.apiUrl}service-categories/`);
  }
}
